import styled, { css } from 'styled-components';
import { palette, theme } from 'styled-tools';
import { minWidth } from '../../utils/mediaQueries';
import { fontSize, FontSizes, fontWeight, FontWeights, lineHeight } from '../../utils/typography';
import { OptionalBackgroundButton } from '../Button';
export const Wrapper = styled(OptionalBackgroundButton) `
	${p => {
    if (p.isDisabled) {
        return css `
				background: ${palette(p.$disabledBackgroundColor)};
				color: ${palette(p.$disabledTextColor)};
			`;
    }
    if (p.$isActive) {
        return css `
				background: ${palette(p.$activeBackgroundColor)};
				color: ${palette(p.$activeTextColor)};
			`;
    }
    return css `
			background: ${palette(p.$inactiveBackgroundColor)};
			color: ${palette(p.$inactiveTextColor)};
		`;
}}
	${lineHeight(FontSizes.sm)};
	min-height: unset;
	min-width: unset;
	${minWidth('desktop')} {
		${fontSize(FontSizes.base)}
		${lineHeight(FontSizes.base)};
		min-height: ${theme('buttons.minHeight')};
		min-width: 48px;
	}
	${fontWeight(FontWeights.Demi)};
	padding: ${theme('buttons.chipButtons.padding')};
	border-radius: ${theme('buttons.chipButtons.borderRadius')};
	&:before {
		inset: ${p => -p.$borderWidth}px;
		border-radius: ${theme('buttons.chipButtons.borderRadius')};
		height: calc(100% + ${p => p.$borderWidth * 2}px);
		width: calc(100% + ${p => p.$borderWidth * 2}px);
	}
	&:after {
		border-radius: calc(${theme('buttons.chipButtons.borderRadius')} - ${theme('buttons.focusRingDistance')});
	}
	border-width: ${p => p.$borderWidth}px;
`;
//# sourceMappingURL=styles.js.map